export enum Plan {
    FREE = 'free',
    PRO = 'pro',
    PREMIUM = 'premium'
}